import { DefaultLoader, LoaderContainer } from 'components/Loader';
import UserInformationDisplay from 'components/UserInformation/UserInformationDisplay';
import { FC } from 'react';
import styled from 'styled-components';
import useSWR from 'swr';
import User from 'types/User';

const Container = styled.div`
  div:first-child {
    border-top: none;
  }
`;

const Information: FC = () => {
  const { data, error } = useSWR<User>('/auth/detailed-profile');
  return data && !error ? (
    <Container>
      <UserInformationDisplay
        user={data}
        variant={
          data?.UserRole?.some((userRole) => userRole.role === 'MENTOR')
            ? 'mentor'
            : 'mentee'
        }
        reader={
          data?.UserRole?.some((userRole) => userRole.role === 'MENTOR')
            ? 'mentor'
            : 'mentee'
        }
      />
    </Container>
  ) : (
    <LoaderContainer>
      <DefaultLoader size={1.5} />
    </LoaderContainer>
  );
};

export default Information;
